import React from "react";
import {useSelector} from "react-redux";

import {mb} from "@pg-design/helpers-css";
import {FormikForm} from "@pg-mono/formik-utils";

import {IRPStore} from "../../../app/rp_reducer";
import {IEmailVerificationProps} from "../../../user/hooks/use_email_verification";
import {leadModalZindex} from "../../constants/lead/lead_modal_zindex";
import {ApplicationEmailVerificationPopover} from "../ApplicationEmailVerificationPopover";

interface IProps {
    emailNotificationProps: IEmailVerificationProps;
}

export const ApplicationMultiLeadUserDataFormFields = (props: IProps) => {
    const countryCodes = useSelector((store: IRPStore) => store.variables.data?.country_codes ?? []);

    return (
        <>
            <FormikForm.Input name="name" placeholder="Imię i nazwisko" css={mb()} />
            <ApplicationEmailVerificationPopover {...props.emailNotificationProps} popoverPlace="bottom" zIndex={leadModalZindex}>
                <FormikForm.Input name="email" placeholder="Email" css={mb()} />
            </ApplicationEmailVerificationPopover>
            <FormikForm.PhoneField codes={countryCodes} name="phone" placeholder="Telefon" css={mb()} className="bt" />
        </>
    );
};
